<template>
  <div class="addClass">
    <el-card>
      <div>
        <el-row :gutter="20" style="margin-bottom: 10px">
          <el-col :sm="12" :md="5" :lg="4">
            <el-cascader
              style="width: 100%"
              clearable
              v-model="searchForm.campusIds"
              :show-all-levels="false"
              :props="campusListProps"
              placeholder="请选择所属校区"
              :options="campusList"
            ></el-cascader>
          </el-col>
          <el-col :sm="12" :md="5" :lg="4">
            <el-cascader
              class="research-select"
              clearable
              v-model="searchForm.courseIds"
              :show-all-levels="false"
              :props="subjectTreeProps"
              placeholder="请选择所属科目"
              :options="subjectTreeList"
            ></el-cascader>
          </el-col>
          <el-col :sm="12" :md="5" :lg="4">
            <el-input
              v-model="searchForm.className"
              placeholder="请输入班级名称"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="4">
            <el-input
              v-model="searchForm.classroomName"
              placeholder="请输入教室名称"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="4">
            <el-input
              v-model="searchForm.mobile"
              placeholder="请输入学员手机号"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="4" style="text-align: right">
            <el-button type="primary" icon="el-icon-search" @click="classroomCalendar()"
              >查询</el-button
            >
          </el-col>
        </el-row>
        <div style="display: flex">
          <div style="display: flex">
            <div class="rowStyle1"></div>
            <div class="rowStyle3-text">普通</div>
          </div>
          <div style="display: flex">
            <div class="rowStyle2"></div>
            <div class="rowStyle3-text">新课</div>
          </div>
          <div style="display: flex">
            <div class="rowStyle3"></div>
            <div class="rowStyle3-text">调课</div>
          </div>
          <div style="display: flex">
            <div class="rowStyle4"></div>
            <div class="rowStyle3-text">停课</div>
          </div>
          <div style="display: flex">
            <div class="rowStyle5"></div>
            <div class="rowStyle3-text">结课</div>
          </div>
        </div>
      </div>
      <el-tabs
        v-loading="loading"
        type="card"
        style="margin-top: 20px"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="周" name="first">
          <el-button-group class="calendar-button">
            <el-button size="small" class="calendar-button1" @click="lastWeek"
              >上一周</el-button
            >
            <el-button size="small" class="calendar-button1" @click="nowWeek"
              >今天</el-button
            >
            <el-button size="small" class="calendar-button1" @click="nextWeek"
              >下一周</el-button
            >
          </el-button-group>
          <el-calendar :range="currentWeekDate">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div :class="data.isSelected ? 'is-selected' : ''">
                {{ data.day.split("-").slice(2).join("-") }}
              </div>
              <div v-for="(item, index) in calendarData" :key="index">
                <div
                  v-if="
                    item.date.split('-')[1].indexOf(data.day.split('-').slice(1)[0]) != -1
                  "
                >
                  <div
                    v-if="
                      item.date
                        .split('-')[2]
                        .indexOf(data.day.split('-').slice(2).join('-')) != -1
                    "
                  >
                    <div v-for="(items, indexs) in item.data" :key="indexs">
                      <el-tooltip class="item" effect="light" placement="right">
                        <div slot="content">
                          <div class="calendar-solt1">
                            {{
                              items.subjectCourse.name + "-第" + items.sequence + "课时"
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课时间:{{ items.schedulePeriod.beginTime }}-{{
                              items.schedulePeriod.endTime
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课老师:{{ items.teacher.name }}
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{ items.classroom.name }}
                          </div>
                          <div class="calendar-solt3"></div>
                          <div style="float: right">
                            <el-button
                              v-if="items.courseState !== 4"
                              type="text"
                              @click="changingCourse(items)"
                              >调课</el-button
                            >
                            <el-button
                              v-if="items.courseState !== 4"
                              type="text"
                              @click="suspendClass(items)"
                              >停课</el-button
                            >
                            <el-button
                              v-if="items.courseState === 4"
                              type="text"
                              @click="resumeClass(items)"
                              >复课</el-button
                            >
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === -1"
                          class="classManage-study0"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 1"
                          class="classManage-study1"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 2"
                          class="classManage-study4"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 3"
                          class="classManage-study2"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 4"
                          class="classManage-study3"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-calendar>
        </el-tab-pane>
        <el-tab-pane label="月" name="second">
          <!-- <el-date-picker  v-model="value1" type="date" placeholder="选择日期"></el-date-picker> -->
          <el-calendar v-model="currentDate">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div :class="data.isSelected ? 'is-selected' : ''">
                {{ data.day.split("-").slice(2).join("-") }}
              </div>
              <div v-for="(item, index) in calendarData" :key="index">
                <div
                  v-if="
                    item.date.split('-')[1].indexOf(data.day.split('-').slice(1)[0]) != -1
                  "
                >
                  <div
                    v-if="
                      item.date
                        .split('-')[2]
                        .indexOf(data.day.split('-').slice(2).join('-')) != -1
                    "
                  >
                    <div v-for="(items, indexs) in item.data" :key="indexs">
                      <el-tooltip class="item" effect="light" placement="right">
                        <div slot="content">
                          <div class="calendar-solt1">
                            {{
                              items.subjectCourse.name + "-第" + items.sequence + "课时"
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课时间:{{ items.schedulePeriod.beginTime }}-{{
                              items.schedulePeriod.endTime
                            }}
                          </div>
                          <div class="calendar-solt2">
                            上课老师:{{ items.teacher.name }}
                          </div>
                          <div class="calendar-solt2">
                            上课教室:{{ items.classroom.name }}
                          </div>
                          <div class="calendar-solt3"></div>
                          <div style="float: right">
                            <el-button
                              v-if="items.courseState !== 4"
                              type="text"
                              @click="changingCourse(items)"
                              >调课</el-button
                            >
                            <el-button
                              v-if="items.courseState !== 4"
                              type="text"
                              @click="suspendClass(items)"
                              >停课</el-button
                            >
                            <el-button
                              v-if="items.courseState === 4"
                              type="text"
                              @click="resumeClass(items)"
                              >复课</el-button
                            >
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === -1"
                          class="classManage-study0"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 1"
                          class="classManage-study1"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 2"
                          class="classManage-study4"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 3"
                          class="classManage-study2"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                        <div
                          v-if="items.courseState === 4"
                          class="classManage-study3"
                          type="size"
                        >
                          <div class="text-width">
                            {{ items.classInfo.name }}-{{ items.subjectCourse.name }}
                          </div>
                          <div class="number-type">
                            {{ items.sequence }}/{{ items.plan.courseNumber }}
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-calendar>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog
      class="addDialog"
      title="调课"
      width="400px"
      :visible.sync="changeCourseDialog"
    >
      <el-form
        :model="changeCourseForm"
        status-icon
        ref="addForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="上课教室" prop="campusId">
          <el-select
            placeholder="请选择上课教室"
            style="width: 100%"
            v-model="changeCourseForm.classroomId"
            clearable
          >
            <el-option
              v-for="item in classroomList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上课老师" prop="name">
          <el-select
            placeholder="请选择上课老师"
            style="width: 100%"
            v-model="changeCourseForm.teacherId"
            clearable
          >
            <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上课日期" prop="date">
          <el-date-picker
            style="width: 100%"
            v-model="changeCourseForm.date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上课时间" prop="address">
          <el-select
            placeholder="请选择上课时间"
            style="width: 100%"
            v-model="changeCourseForm.schedulePeriodId"
            clearable
          >
            <el-option
              v-for="item in periodList"
              :key="item.id"
              :label="item.beginTime + '-' + item.endTime"
              :value="item.id"
            ></el-option>
          </el-select>
          <!-- <el-row>
            <el-col :span="11">
              <el-time-select
                style="width:100%"
                placeholder="起始时间"
                v-model="changeCourseForm.beginTime"
                :picker-options="{
                start: '06:00',
                step: '00:15',
                end: '24:00'
              }"
              ></el-time-select>
            </el-col>
            <el-col :span="2">
              <div class="time-selectType">至</div>
            </el-col>
            <el-col :span="11">
              <el-time-select
                style="width:100%"
                placeholder="结束时间"
                v-model="changeCourseForm.endTime"
                :picker-options="{
                start: '06:00',
                step: '00:15',
                end: '24:00',
                minTime: changeCourseForm.beginTime
              }"
              ></el-time-select>
            </el-col>
          </el-row>-->
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="changeCourseDialog = false">取消</el-button>
          <el-button type="primary" @click="transferClass">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      activeName: "second",
      currentDate: new Date(),
      currentWeekDate: [
        moment(new Date()).startOf("week").subtract(-1, "days").format("YYYY-MM-DD"),
        moment(new Date()).endOf("week").subtract(-1, "days").format("YYYY-MM-DD"),
      ],
      searchForm: {
        campusIds: [],
        courseIds: [],
      },
      calendarData: [],
      classroomList: [],
      teacherList: [],
      subjectTreeList: [],
      periodList: [],
      changeCourseDialog: false,
      changeCourseForm: {},
      campusListProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      campusList: [],
      periodPage: {
        pageNumber: 1,
        pageSize: 100,
      },
    };
  },
  methods: {
    //获取城市
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  delete items.children;
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeListByAgentId()
        .then((result) => {
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  if (items.children) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.subjectTreeList = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changingCourse(item) {
      console.log("item", item);
      this.changeCourseForm = {};
      this.api.agentUserInfo
        .getTeacherList({ campusId: item.campusId })
        .then((result) => {
          if (result.success) {
            this.teacherList = result.data;
            if (this.teacherList.length === 0) {
              this.$message.error("该校区暂无老师，请添加老师信息");
            }
          } else {
            this.$message.error(result.message);
          }
        });
      this.api.classroom.getClassroomList({ campusId: item.campusId }).then((result) => {
        if (result.success) {
          this.classroomList = result.data;
          if (this.classroomList.length === 0) {
            this.$message.error("该校区暂无教室，请添加教室信息");
          }
          this.$set(this.changeCourseForm, "classroomId", item.classroomId);
          this.$set(this.changeCourseForm, "teacherId", item.teacherId);
          this.$set(this.changeCourseForm, "date", item.date);
          // this.$set(
          //   this.changeCourseForm,
          //   "beginTime",
          //   item.schedulePeriod.beginTime
          // );
          // this.$set(
          //   this.changeCourseForm,
          //   "endTime",
          //   item.schedulePeriod.endTime
          // );
          this.$set(this.changeCourseForm, "classInfoId", item.classInfoId);
          this.$set(this.changeCourseForm, "schedulePeriodId", item.schedulePeriodId);
          this.$set(this.changeCourseForm, "classInfoId", item.classInfoId);
          this.$set(this.changeCourseForm, "id", item.id);
        } else {
          this.$message.error(result.message);
        }
      });
      // this.changeCourseForm.classroomId = item.classroomId;
      // this.changeCourseForm.teacherId = item.teacherId;
      // this.changeCourseForm.date = item.date;
      this.periodPageList();
      this.changeCourseDialog = true;
    },
    //获取时间段
    periodPageList() {
      this.api.schedulePeriod
        .pageList(this.periodPage)
        .then((result) => {
          if (result.success) {
            this.periodList = result.data.records;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    transferClass() {
      this.api.scheduleInfo.transferClass(this.changeCourseForm).then((result) => {
        if (result.success) {
          this.changeCourseDialog = false;
          this.classroomCalendar();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    suspendClass(item) {
      this.$confirm("您确定要进行停课操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.scheduleInfo.suspendClass({ id: item.id }).then((result) => {
          if (result.success) {
            this.classroomCalendar();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    resumeClass(item) {
      this.api.scheduleInfo.resumeClass({ id: item.id }).then((result) => {
        if (result.success) {
          this.classroomCalendar();
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取老师列表
    getTeacherList(id) {
      this.api.agentUserInfo.getTeacherList({ campusId: id }).then((result) => {
        if (result.success) {
          this.teacherList = result.data;
          if (this.teacherList.length === 0) {
            this.$message.error("该校区暂无老师，请添加老师信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    //获取教室列表
    getClassroomList(id) {
      this.api.classroom.getClassroomList({ campusId: id }).then((result) => {
        if (result.success) {
          this.classroomList = result.data;
          if (this.classroomList.length === 0) {
            this.$message.error("该校区暂无教室，请添加教室信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },

    handleClick(tab, event) {
      this.calendarData = [];
      if (tab.name === "first") {
        this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
      }
      if (tab.name === "second") {
        this.classroomCalendar();
      }
    },
    //获取日历课程
    classroomCalendar(beginDate, endDate) {
      this.loading = true;
      this.calendarData = [];
      let obj = {};
      if (beginDate) {
        obj = {
          beginDate: beginDate,
          endDate: endDate,
          campusId: this.searchForm.campusIds ? this.searchForm.campusIds[1] : "",
          courseId: this.searchForm.courseIds ? this.searchForm.courseIds[2] : "",
          teacherName: this.searchForm.teacherName,
          classroomName: this.searchForm.classroomName,
          className: this.searchForm.className,
          mobile: this.searchForm.mobile,
        };
      } else {
        obj = {
          beginDate: moment()
            .month(moment().month())
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().month(moment().month()).endOf("month").format("YYYY-MM-DD"),
          campusId: this.searchForm.campusIds ? this.searchForm.campusIds[1] : "",
          courseId: this.searchForm.courseIds ? this.searchForm.courseIds[2] : "",
          teacherName: this.searchForm.teacherName,
          classroomName: this.searchForm.classroomName,
          className: this.searchForm.className,
          mobile: this.searchForm.mobile,
        };
      }
      this.api.classInfo.scheduleCalendar(obj).then((result) => {
        if (result.success) {
          this.calendarData = result.data;
        } else {
          this.$message.error(result.message);
        }
        this.loading = false;
      });
    },
    lastWeek() {
      this.currentWeekDate = [
        moment(this.currentWeekDate[0]).subtract(7, "days").format("YYYY-MM-DD"),
        moment(this.currentWeekDate[1]).subtract(7, "days").format("YYYY-MM-DD"),
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
    nextWeek() {
      this.currentWeekDate = [
        moment(this.currentWeekDate[0]).subtract(-7, "days").format("YYYY-MM-DD"),
        moment(this.currentWeekDate[1]).subtract(-7, "days").format("YYYY-MM-DD"),
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
    nowWeek() {
      this.currentWeekDate = [
        moment(this.nowTime).startOf("week").subtract(-1, "days").format("YYYY-MM-DD"),
        moment(this.nowTime).endOf("week").subtract(-1, "days").format("YYYY-MM-DD"),
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
  },
  computed: {},
  mounted() {
    this.classroomCalendar();
    this.getCampusList();
    this.getSubjectTreeList();
  },
  watch: {
    currentDate(nVal) {
      let beginDate = moment(this.currentDate).startOf("month").format("YYYY-MM-DD");
      let endDate = moment(this.currentDate).endOf("month").format("YYYY-MM-DD");
      this.classroomCalendar(beginDate, endDate);
    },
  },
};
</script>
<style scoped>
.addClass-tag {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.addClass-button {
  margin-top: 20px;
  margin-bottom: 20px;
}
.rowStyle1 {
  width: 14px;
  height: 14px;
  border-radius: 0px;
  background-color: #4d94ff;
  margin-left: 0px;
  margin-top: 10px;
}
.rowStyle2 {
  width: 14px;
  height: 14px;
  border-radius: 0px;
  background-color: #24d2b5;
  margin-left: 20px;
  margin-top: 10px;
}
.rowStyle3 {
  width: 14px;
  height: 14px;
  background-color: #ffc349;
  border-radius: 0px;
  margin-left: 20px;
  margin-top: 10px;
}
.rowStyle3-text {
  line-height: 15px;
  margin-left: 5px;
  margin-top: 10px;
}
.rowStyle4 {
  width: 14px;
  height: 14px;
  border-radius: 0px;
  background-color: #ff5555;
  margin-left: 20px;
  margin-top: 10px;
}
.rowStyle5 {
  width: 14px;
  height: 14px;
  background-color: #a2aabc;
  border-radius: 0px;
  margin-left: 20px;
  margin-top: 10px;
}
.addClass-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
  margin-left: 10px;
}
.time-selectType {
  text-align: center;
  width: 100%;
  line-height: 40px;
}
.classInfoType {
  cursor: pointer;
  margin-left: 22px;
  margin-top: 10px;
}
.classManage-study0 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  margin-top: 2px;
  border-left: 2px solid rgba(77, 148, 255, 1);
  background-color: rgba(77, 148, 255, 0.0980392156862745);
  overflow: hidden;
}
.classManage-study1 {
  display: block;
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #24d2b5;
  margin-top: 2px;
  border-left: 2px solid #24d2b5;
  background-color: rgba(36, 210, 181, 0.0980392156862745);
  overflow: hidden;
}
.classManage-study2 {
  display: block;
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #ffc349;
  margin-top: 2px;
  border-left: 2px solid #ffc349;
  background-color: rgba(255, 195, 73, 0.0980392156862745);
  overflow: hidden;
}
.classManage-study3 {
  display: block;
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #ff5555;
  margin-top: 2px;
  border-left: 2px solid #ff5555;
  background-color: rgba(255, 85, 85, 0.0980392156862745);
  overflow: hidden;
}
.classManage-study4 {
  display: block;
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #455a64;
  margin-top: 2px;
  border-left: 2px solid #a2aabc;
  background-color: rgba(162, 170, 188, 0.0980392156862745);
  overflow: hidden;
}
.calendar-solt1 {
  font-size: 16px;
  color: #455a64;
  font-weight: 600;
  width: 200px;
}
.calendar-solt2 {
  font-size: 13px;
  margin-top: 10px;
}
.calendar-solt3 {
  border-top: 1px solid #e4e7ed;
  margin-top: 10px;
}
.calendar-button {
  float: right;
}
.calendar-button1 {
  height: 28px;
  line-height: 10px;
}
@media screen and (min-width: 1200px) {
  .text-width {
    max-width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    float: left;
  }
}
@media screen and (min-width: 800px) {
  .text-width {
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    float: left;
  }
}

.number-type {
  color: #a2aabc;
  float: right;
}
</style>
<style lang="less">
.addClass {
  .el-calendar-table .el-calendar-day {
    min-height: 150px !important;
  }
}
.el-calendar-table .el-calendar-day {
  height: 150px !important;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/classManage/classSchedule.vue